import styled, { css } from 'styled-components';


export const OptionContainer = styled.div<{selected:boolean}>`
  position: relative;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  overflow: hidden;
  box-sizing: border-box;

  & img {
    border: 3px solid ${(props) => props.theme.colors.lightGray};
    transition: all 0.2s linear;
  }

  ${(props) => props.selected && css`
    & img {
      border-color: ${(props) => props.theme.colors.backgroundBlack};
    }
  `}
`;

export const OptionLabelContainer = styled.div`
  width: 100%;
  text-align: center;
`;

export const OptionImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const SliderMenuOptionImage = styled.img`
  object-fit: cover;
  border-radius: 50%;
  box-sizing: border-box;
`;

export const SliderMenuSpacer = styled.div<{width:number}>`
  width: ${(props) => props.width}px;
  min-width: ${(props) => props.width}px;
  max-width: ${(props) => props.width}px;
`;

export const SliderMenuInnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: scroll;
  scroll-behavior: smooth;
`;

export const SliderMenuContainer = styled.div<{optionTileWidth:number, optionTileHeight:number, imageSize:number}>`
  display: block;
  max-height: ${(props) => props.optionTileHeight}px;
  width: 100%;
  overflow: hidden;

  & ${OptionContainer} {
    width: ${(props) => props.optionTileWidth}px;
    min-width: ${(props) => props.optionTileWidth}px;
    max-width: ${(props) => props.optionTileWidth}px;
    height: ${(props) => props.optionTileHeight}px;
    max-height: ${(props) => props.optionTileHeight}px;
  };

  & ${SliderMenuOptionImage} {
    width: ${(props) => props.imageSize}px;
    height: ${(props) => props.imageSize}px;
  };

  & ${SliderMenuOptionImage}.selected {
    width: ${(props) => props.imageSize*1.14}px;
    height: ${(props) => props.imageSize*1.14}px;
  };

  & ${OptionLabelContainer} {
    height: ${(props) => props.optionTileHeight/3}px;
    min-height: ${(props) => props.optionTileHeight/3}px;
    max-height: ${(props) => props.optionTileHeight/3}px;
    font-size: ${(props) => props.optionTileHeight*0.128}px;
    line-height: ${(props) => props.optionTileHeight*0.128}px;
    white-space: nowrap;
  }
`;